module.exports = __webpack_public_path__ + "img/girls-school-laughing.7adaf5d5.jpg";